import { render } from "./DataSourceTableRowItem.vue?vue&type=template&id=1cb2fda6&ts=true"
import script from "./DataSourceTableRowItem.vue?vue&type=script&lang=ts"
export * from "./DataSourceTableRowItem.vue?vue&type=script&lang=ts"

import "./DataSourceTableRowItem.vue?vue&type=style&index=0&id=1cb2fda6&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__